import * as MarketAssumedValuesModel from './MarketAssumedValuesModel';

export interface ICloneSrecPriceCurveRequest {
    codeOfSrecPriceCurveToBeCloned: string;
    updatedSrecPriceCurveName: string;
    updatedSrecPriceCurveCode: string;
}

export class CloneSrecPriceCurveRequest implements ICloneSrecPriceCurveRequest {
    codeOfSrecPriceCurveToBeCloned: string;
    updatedSrecPriceCurveName: string;
    updatedSrecPriceCurveCode: string;

    constructor(basePriceCurvesModel: MarketAssumedValuesModel.ISrecPriceCurves) {
        this.codeOfSrecPriceCurveToBeCloned = basePriceCurvesModel.code;
        this.updatedSrecPriceCurveName = basePriceCurvesModel.name + ' (Clone)';
    }
}